import * as React from "react"
import type { IconProps } from "../types"

const ChevronUpDown = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M8 9L12 5L16 9M16 15L12 19L8 15"
        />
      </svg>
    )
  }
)
ChevronUpDown.displayName = "ChevronUpDown"

export default ChevronUpDown
